import { createInMemoryAtom } from '@exodus/atoms';
const createOptimisticBalancesAtom = () => createInMemoryAtom();
export default createOptimisticBalancesAtom;
